






















import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ContentFeed, ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { shareUrl } from "@/lib/urlHelpers";
import { BaseMenuItem } from "@/types";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseMenu from "@/components/BaseMenu";

export default defineComponent({
  name: "ContentFeedItemMenu",
  components: { BaseMenu, BaseConfirm, BaseButton },
  props: {
    contentFeed: { type: Object as PropType<ContentFeed>, required: true },
    showReportItem: { type: Boolean, default: true },
    showShare: { type: Boolean, default: true },
    isPinned: { type: Boolean, default: false },
    enablePinPost: { type: Boolean, default: false },
    shareLink: { type: String, required: true },
    activatorClass: { type: String },
  },
  setup(props, { root }) {
    const { authUser, authorities, isFullCreator } = useAuthUser();
    const showReportConfirm = ref(false);
    const processingError = computed(
      () =>
        props.contentFeed.processingStatus === "ERROR" &&
        authUser.value &&
        authUser.value?.id === props.contentFeed.userId
    );
    const iconName = computed(() => (processingError.value ? "sci-color-error" : "sci-dots-vertical"));
    const isAuthor = computed(() => !!authUser.value && authUser.value?.id === props.contentFeed.userId);
    const canUpdateContentSet = computed(
      () =>
        props.contentFeed.type !== ContentFeedTypeEnum.STORY &&
        checkAuthorities(
          authorities.value ?? [],
          isAuthor.value && isFullCreator.value ? ["updateMyContentSet"] : ["updateAnyContentSet"]
        )
    );
    const canDeleteContentSet = computed(() =>
      checkAuthorities(authorities.value ?? [], isAuthor.value ? ["deleteMyContentSet"] : ["deleteAnyContentSet"])
    );

    const menuItems = computed(() => {
      const menuItems: BaseMenuItem[] = [];
      if (props.showShare) {
        menuItems.push({
          name: "share",
          class: "feed-item__menu__share",
          text: $t("Share"),
        });
      }
      if (canUpdateContentSet.value) {
        menuItems.push({
          name: "edit-post",
          text: $t("Edit"),
          prependIcon: processingError.value ? "sci-color-error" : undefined,
        });
      }
      if (props.enablePinPost) {
        menuItems.push({
          name: "pin-post",
          text: props.isPinned ? $t("Unpin from your profile") : $t("Pin to your profile"),
        });
      }
      if (canDeleteContentSet.value) {
        menuItems.push({
          name: "delete-post",
          text: $t("Delete"),
        });
      }
      if (props.showReportItem) {
        menuItems.push({
          name: "report-post",
          text: $t("Report"),
        });
      }
      return menuItems;
    });
    const onEditPost = () => {
      emitter.emit(EVENTS.SHOW_CREATE_POST, {
        postId: props.contentFeed.id,
        userId: props.contentFeed.userId,
        type: props.contentFeed.type,
      });
    };

    const onConfirmReport = () => {
      const baseUrl = location.origin;
      const userName = props.contentFeed.user.username;
      const postId = props.contentFeed.id;

      root.$router.push({ name: "complaints", query: { contentUrl: `${baseUrl}/${userName}?feedId=${postId}` } });
    };

    const onShareClick = () => {
      shareUrl(props.shareLink, $t("Link copied"));
    };
    return {
      showReportConfirm,
      iconName,
      menuItems,
      onEditPost,
      onConfirmReport,
      onShareClick,
    };
  },
});
